module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding@3x-8f9f38180c92122125f38507c4cd099e.webp";